import * as Sentry from '@sentry/react';

/* El acceso a localStorage lanza SecurityError cuando el navegador bloquea el
   almacenamiento del sitio: modo privado, cookies de terceros deshabilitadas, o
   la página embebida en el WebView de otra app. Sentry registró el caso dentro
   de un handler de socket.io, donde la excepción cortaba la conexión y el
   usuario nunca recibía la respuesta del servidor. */

const storageFor = (storeType) =>
  storeType === 'session' ? window.sessionStorage : window.localStorage;

/* Un navegador que bloquea el almacenamiento falla en cada llamada: se reporta
   una vez por operación para no inundar Sentry. */
const reported = new Set();

const report = (operation, error) => {
  if (reported.has(operation)) return;

  reported.add(operation);

  Sentry.captureException(error, { tags: { storage: operation } });
};

export const setItem = (key, value, storeType) => {
  try {
    storageFor(storeType).setItem(key, value);
  } catch (error) {
    report(`setItem:${key}`, error);
  }
};

export const getItem = (key, storeType) => {
  try {
    return storageFor(storeType).getItem(key);
  } catch (error) {
    report(`getItem:${key}`, error);

    return null;
  }
};

export const clear = (storeType) => {
  try {
    storageFor(storeType).clear();
  } catch (error) {
    report('clear', error);
  }
};
